<template>
  <div class="event-transfers">
    <modal :title="title" :subtitle="''"
      v-on:close="switchModal"
      v-if="modal">
      <transfer v-on:close="switchModal" :data="editableTransfer"/>
    </modal>
    <div class="transfers-actions">
      <nav-bar :dataFunction="getTransfers" :orderFields="orderFields"/>
      <button v-if="permissionsStatus.isTransferCreateAllowed"
        class="ccs-button ccs-button--white ccs-button--small" @click="switchModal">
        <img src="@/assets/icons/add.svg" alt="" class="button-icon">
        Добавить трансфер
      </button>
    </div>
    <div v-for="transfer in eventTransfers" :key="transfer.id"
      class="transfer"
      :class="{ 'transfer--editable': permissionsStatus.isTransferUpdateAllowed ||
                                      permissionsStatus.isTransferDeleteAllowed }"
      @click="startEditing(transfer)">
      <div class="departure">
        <div class="transfer-title">
          Отправление
        </div>
        <div class="transfer-point">
          {{ transfer.departure_point }}
        </div>
        <div class="transfer-date">
          {{ getDisplayText(transfer.departure_date) }}
        </div>
      </div>
      <div class="arrive">
        <div class="transfer-title">
          Прибытие
        </div>
        <div class="transfer-point">
          {{ transfer.arrival_point }}
        </div>
        <div class="transfer-date">
          {{ getDisplayText(transfer.departure_date) }}
        </div>
      </div>
      <div class="transfer-tansport">
        <div class="transfer-title">
          Транспорт
        </div>
        {{ transfer.transport_type }}
      </div>
      <div class="transfer-description">
        <div class="transfer-title">
          Описание
        </div>
        {{ transfer.description }}
      </div>
    </div>
    <pagination :dataFunction="getTransfers"/>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';

import Modal from '@/components/Modal.vue';
import Transfer from '@/components/modals/transfers/Transfer.vue';
import NavBar from '@/components/NavBar.vue';
import Pagination from '@/components/Pagination.vue';

export default {
  name: 'Transfers',
  components: {
    Modal,
    Transfer,
    NavBar,
    Pagination,
  },
  data() {
    return {
      orderFields: [{
        prop: 'departure_point',
        text: 'Месту отправления',
      }, {
        prop: 'arrival_point',
        text: 'Месту прибытия',
      }, {
        prop: 'departure_date',
        text: 'Дате отправления',
      }, {
        prop: 'arrival_date',
        text: 'Дате прибытия',
      }, {
        prop: 'transport_type',
        text: 'Типу транспорта',
      }, {
        prop: 'transport_make',
        text: 'Марке транспорта',
      }, {
        prop: 'transport_number',
        text: 'Номеру транспорта',
      }],
      modal: false,
      editableTransfer: null,
      titles: {
        new: 'Новый трансфер',
        edit: 'Редактирование трансфера',
      },
      dateFormatOptions: {
        day: 'numeric',
        year: 'numeric',
        month: 'long',
        hour: 'numeric',
        minute: 'numeric',
      },
    };
  },
  computed: {
    ...mapState('events', ['eventTransfers']),
    ...mapGetters('session', ['permissionsStatus']),
    title() {
      return this.editableTransfer ? this.titles.edit : this.titles.new; 
    },
  },
  methods: {
    ...mapActions('events', ['getTransfers']),
    switchModal() {
      this.modal = !this.modal;
      if (this.editableTransfer) {
        this.editableTransfer = null;
      }
    },
    startEditing(transfer) {
      if (this.permissionsStatus.isTransferUpdateAllowed ||
          this.permissionsStatus.isTransferDeleteAllowed) {
        this.switchModal();
        this.editableTransfer = Object.assign({}, transfer);
      }
    },
    getDisplayText(data) {
      let date = new Date(data);
      return date.toLocaleString('ru-RU', this.dateFormatOptions);
    }
  },
  mounted() {
    this.getTransfers();
  },
};
</script>

<style lang="scss" scoped>
.event-transfers {
  min-height: 100%;
  min-width: 100%;

  .transfers-actions {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .transfer {
    box-sizing: border-box;
    margin-top: 20px;
    padding: 20px;
    min-height: 100px;
    width: 100%;
    display: flex;
    align-items: stretch;
    border-radius: 5px;
    box-shadow: 0 0 10px rgba(129, 129, 129, 0.2);

    > div:not(:last-child) {
      margin-right: 30px;
    }

    &--editable {
      cursor: pointer;
    }

    &-title {
      margin-bottom: 10px;
      color: #000;
      font-size: 12px;
      font-weight: bold;
    }

    &-point {
      margin-bottom: 5px;
      color: $primary;
      font-size: 20px;
      font-weight: bold;
    }

    &-date {
      font-size: 12px;
    }

    &-tansport {
      color: $primaryLighter;
      font-size: 14px;
      font-weight: bold;
    }

    &-description {
      max-width: 25%;
      justify-self: end;
      margin-left: auto;
      font-size: 14px;
    }

  }

  .button--add {
    margin-top: 22px;
  }

}
</style>
